import React, { useMemo } from "react";
import TopBarStats from "./TopBarStats.jsx";
import { useDashboardOverview } from "../../context/DashboardOverviewContext.jsx";
import {
  resolveDisplayDayGoalH,
  resolveDisplayWeekGoalH,
} from "../../constants/workTimeDisplay.js";

const TOPBAR_FALLBACK = {
  year: {
    elapsed: 0,
    total: 261,
    fulfilled: 0,
    percentElapsed: 0,
    percentFulfilled: 0,
  },
  day: { actual: 0, goal: resolveDisplayDayGoalH(undefined, null) },
  week: { actual: 0, goal: resolveDisplayWeekGoalH(undefined, null) },
  month: { actual: 0, goal: 0 },
};

export function mapTopminiToTopbar(d) {
  if (!d || typeof d !== "object") return null;
  const ui = d.uiWorkDefaults || null;
  return {
    year: {
      elapsed: d?.year?.elapsed ?? 0,
      total: d?.year?.total ?? 0,
      fulfilled: d?.year?.fulfilled ?? 0,
      percentElapsed: d?.year?.percentElapsed ?? 0,
      percentFulfilled: d?.year?.percentFulfilled ?? 0,
    },
    day: {
      actual: typeof d?.day?.actual === "number" ? d.day.actual : 0,
      goal: resolveDisplayDayGoalH(d?.day?.goal, ui),
    },
    week: {
      actual: typeof d?.week?.actual === "number" ? d.week.actual : 0,
      goal: resolveDisplayWeekGoalH(d?.week?.goal, ui),
    },
    month: {
      actual: typeof d?.month?.actual === "number" ? d.month.actual : 0,
      goal: typeof d?.month?.goal === "number" && Number.isFinite(d.month.goal) ? d.month.goal : 0,
    },
    uiWorkDefaults: ui,
  };
}

export default function DashboardTopBarKpis() {
  const { data, loading } = useDashboardOverview();
  const topbar = useMemo(() => mapTopminiToTopbar(data?.topmini), [data?.topmini]);

  if (loading && !topbar) {
    return (
      <div className="mb-4 sm:mb-6 animate-pulse" aria-busy="true" aria-label="KPIs werden geladen">
        <div className="rounded-2xl h-[52px] border border-white/10 bg-white/5" />
      </div>
    );
  }

  return (
    <div className="mb-4 sm:mb-6" aria-live="polite">
      <TopBarStats data={topbar || TOPBAR_FALLBACK} />
    </div>
  );
}
